var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(
      false && 
      _vm.$route.name && 
      _vm.isNew() && 
      _vm.$route.name.indexOf('Live') == -1 && 
      _vm.$route.name.indexOf('UserCenter') == -1 && 
      _vm.$route.name.indexOf('Login') == -1 && 
      _vm.$route.name.indexOf('Ticket') == -1 && 
      _vm.$route.name.indexOf('Order') == -1 
    )?_c('Popup'):_vm._e(),(
      false && 
      _vm.$route.name && 
      _vm.isNew() && 
      _vm.$route.name.indexOf('LiveSchedule') == -1 && 
      _vm.$route.name.indexOf('Live') == -1 && 
      _vm.$route.name.indexOf('UserCenter') == -1 && 
      _vm.$route.name.indexOf('Login') == -1 && 
      _vm.$route.name.indexOf('Ticket') == -1 && 
      _vm.$route.name.indexOf('Order') == -1 
    )?_c('popup-live'):_vm._e(),(_vm.$route.name)?_c('Header'):_vm._e(),_c('router-view'),_c('Footer',{key:'ztup_footer'+_vm.showFooter}),(
      _vm.$route.name && 
      _vm.$route.name.indexOf('Live') == -1 && 
      _vm.$route.name.indexOf('Ticket') == -1 && 
      _vm.$route.name.indexOf('Order') == -1 
    )?_c('Bottom'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }